import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Select, { SelectLabelDefault } from '@carvana/forms/Select';
import { PossibleSuffixesNext } from './possible-suffixes';

const StyledSuffixNext = styled(Select)`
  height: 60px;
`;

const CustomLabel = styled(SelectLabelDefault)`
  label {
    font-size: 12px;
    font-weight: 400;
    text-transform: capitalize;
  }
  span {
    font-size: 14px;
    font-weight: 500;
    text-transform: capitalize;
  }
`;

const SuffixNext = props => {
  return (
    <StyledSuffixNext
      {...props}
      MenuLabel={CustomLabel}
      data-cv-test="nameSuffix"
      label="Suffix"
      options={PossibleSuffixesNext}
    />
  );
};

SuffixNext.propTypes = {
  'data-cv-test': PropTypes.string
};

SuffixNext.defaultProps = {
  'data-cv-test': 'suffix'
};

export default SuffixNext;
